import InteractiveModal from '@/components/common/InteractiveModal/InteractiveModal';

export default InteractiveModal;
